// import React, { useState } from "react";
// import styles from "../styles/AncillaryFSICalculator.module.css";
// import { useNavigate } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";

// const cityPercentageMap = {
//   "Pune": 0.15,
//   "Thane": 0.15,
//   "Nagpur": 0.10,
//   "Nashik Municipal Corporation": 0.10,
//   "Other M.M.R. Municipal Corporations": 0.10,
//   "CIDCO": 0.10,
//   "All other Municipal Corporations": 0.10,
//   "Municipal Councils": 0.10,
//   "Nagar Panchayats": 0.10,
//   "R.P. area": 0.10,
// };

// const AncillaryFSICalculator = () => {
//   const [converterType, setConverterType] = useState("Premium for Ancillary FSI");
//   const [cityType, setCityType] = useState("Nashik Municipal Corporation");
//   const [fsiArea, setFsiArea] = useState(""); 
//   const [rrRate, setRrRate] = useState(""); 
//   const [premium, setPremium] = useState(""); 

//   const navigate = useNavigate();

//   const handleBack = () => navigate(-1);

//   const handleDropdownChange = (e) => {
//     const selected = e.target.value;
//     setConverterType(selected);

//     const pathMap = {
//       "Area Convertor": "/area-convertor",
//       "Built-up Area Calculator": "/built-up-area-calculator",
//       "Development Charges": "/development-charges",
//       "Premium for Ancillary FSI": "/ancillary-fsi",
//       "⁠Premium for Premium FSI": "/premium-fsi",
//       "ULC Premium": "/ulc-premium",
//     };
//     if (pathMap[selected]) navigate(pathMap[selected]);
//   };

//   const handleSubmit = () => {
//     const area = parseFloat(fsiArea);
//     const rate = parseFloat(rrRate);
//     const percentage = cityPercentageMap[cityType] || 0;

//     if (!isNaN(area) && !isNaN(rate)) {
//       setPremium((area * rate * percentage).toFixed(2));
//     } else {
//       setPremium("Invalid input");
//     }
//   };

//   return (
//     <div className={styles.AncillaryFSICalculator_container}>
//       <div className={styles.AncillaryFSICalculator_header}>
//         <button
//           className={styles.AncillaryFSICalculator_backButton}
//           onClick={handleBack}
//         >
//           <FaArrowLeft />
//         </button>
//         <h2 className={styles.AncillaryFSICalculator_title}>Conversion Calculator</h2>
//       </div>

//       <div className={styles.AncillaryFSICalculator_dropdownContainer}>
//         <select
//           value={converterType}
//           onChange={handleDropdownChange}
//           className={styles.AncillaryFSICalculator_mainDropdown}
//         >
//           <option>Area Convertor</option>
//           <option>Built-up Area Calculator</option>
//           <option>Development Charges</option>
//           <option>Premium for Ancillary FSI</option>
//           <option>⁠Premium for Premium FSI</option>
//           <option>ULC Premium</option>
//         </select>
//       </div>

//       <div className={styles.AncillaryFSICalculator_card}>
//         <h3 className={styles.AncillaryFSICalculator_sectionTitle}>Premium Amount</h3>

//         <div className={styles.AncillaryFSICalculator_formGroup}>
//           <label className={styles.AncillaryFSICalculator_label}>City/Town Type</label>
//           <select
//             className={styles.AncillaryFSICalculator_select}
//             value={cityType}
//             onChange={(e) => setCityType(e.target.value)}
//           >
//             {Object.keys(cityPercentageMap).map((city) => (
//               <option key={city} value={city}>{city}</option>
//             ))}
//           </select>
//         </div>

//         <div className={styles.AncillaryFSICalculator_formGroup}>
//           <label className={styles.AncillaryFSICalculator_label}>Ancillary FSI Area (sq.m):</label>
//           <input
//             type="number"
//             className={styles.AncillaryFSICalculator_input}
//             value={fsiArea}
//             onChange={(e) => setFsiArea(e.target.value)}
//           />
//         </div>

//         <div className={styles.AncillaryFSICalculator_formGroup}>
//           <label className={styles.AncillaryFSICalculator_label}>Ready Reckoner Rate (₹/sq.m):</label>
//           <input
//             type="number"
//             className={styles.AncillaryFSICalculator_input}
//             value={rrRate}
//             onChange={(e) => setRrRate(e.target.value)}
//           />
//         </div>

//         <button
//           className={styles.AncillaryFSICalculator_submitButton}
//           onClick={handleSubmit}
//         >
//           Submit
//         </button>

//         <h3 className={styles.AncillaryFSICalculator_resultTitle}>Premium</h3>
//         <p className={styles.AncillaryFSICalculator_resultValue}>
//           {premium ? `₹ ${premium}` : "₹ 0.00"}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default AncillaryFSICalculator;






import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Layers, 
  MapPin, 
  Maximize, 
  TrendingUp, 
  Wallet,
  ChevronRight,
  Info
} from "lucide-react";

const cityPercentageMap = {
  "Pune": 0.15,
  "Thane": 0.15,
  "Nagpur": 0.10,
  "Nashik Municipal Corporation": 0.10,
  "Other M.M.R. Municipal Corporations": 0.10,
  "CIDCO": 0.10,
  "All other Municipal Corporations": 0.10,
  "Municipal Councils": 0.10,
  "Nagar Panchayats": 0.10,
  "R.P. area": 0.10,
};

const AncillaryFSICalculator = () => {
  const [converterType, setConverterType] = useState("Premium for Ancillary FSI");
  const [cityType, setCityType] = useState("Nashik Municipal Corporation");
  const [fsiArea, setFsiArea] = useState(""); 
  const [rrRate, setRrRate] = useState(""); 
  const [premium, setPremium] = useState(""); 

  const navigate = useNavigate();
  const handleBack = () => navigate(-1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  const handleSubmit = () => {
    const area = parseFloat(fsiArea);
    const rate = parseFloat(rrRate);
    const percentage = cityPercentageMap[cityType] || 0;

    if (!isNaN(area) && !isNaN(rate)) {
      setPremium((area * rate * percentage).toLocaleString('en-IN', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      }));
    } else {
      setPremium("Invalid input");
    }
  };

  return (
    /* FIXED: Background darkened to slate-100 for maximum contrast with white card */
    <div className="min-h-screen bg-slate-100 pb-20">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button onClick={handleBack} className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600">
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">TPH Calc</h2>
        </div>
      </div>

      <main className="max-w-2xl mx-auto px-4 mt-10">
        {/* --- TOOL NAVIGATOR --- */}
        <div className="relative mb-10">
          <Layers className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500 z-10" size={18} />
          <select
            value={converterType}
            onChange={handleDropdownChange}
            className="w-full bg-white border border-slate-300 rounded-2xl py-5 pl-12 pr-4 font-bold text-slate-800 appearance-none shadow-md focus:outline-none focus:ring-2 focus:ring-orange-500/20"
          >
            <option>Area Convertor</option>
            <option>Built-up Area Calculator</option>
            <option>Development Charges</option>
            <option>Premium for Ancillary FSI</option>
            <option>⁠Premium for Premium FSI</option>
            <option>ULC Premium</option>
          </select>
          <ChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" size={18} />
        </div>

        {/* --- MAIN CARD --- */}
        {/* FIXED: Increased shadow to shadow-2xl and added ring-1 for a crisp border edge */}
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/40 ring-1 ring-slate-200 overflow-hidden transform transition-all">
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight">Ancillary FSI Premium</h3>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">Regulatory Calculator</p>
            </div>
            <div className="w-10 h-10 bg-orange-600 rounded-xl flex items-center justify-center shadow-lg shadow-orange-900/20">
              <Wallet size={20} />
            </div>
          </div>

          <div className="p-8 space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                <MapPin size={14} /> City / Town Type
              </label>
              <select
                value={cityType}
                onChange={(e) => setCityType(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 font-bold text-slate-700 outline-none focus:bg-white focus:border-orange-500 transition-all shadow-sm"
              >
                {Object.keys(cityPercentageMap).map((city) => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </select>
              <p className="text-[11px] text-orange-600 font-black px-1 mt-2">
                * Applicable Rate: {(cityPercentageMap[cityType] * 100).toFixed(0)}% of RR Rate
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                  <Maximize size={14} /> FSI Area (sq.m)
                </label>
                <div className="relative group">
                  <input
                    type="number"
                    placeholder="0.00"
                    value={fsiArea}
                    onChange={(e) => setFsiArea(e.target.value)}
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 font-black text-slate-900 focus:bg-white focus:border-orange-500 outline-none transition-all shadow-sm"
                  />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">sq.m</span>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                  <TrendingUp size={14} /> RR Rate (₹/sq.m)
                </label>
                <div className="relative group">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-bold text-slate-400">₹</span>
                  <input
                    type="number"
                    placeholder="Rate"
                    value={rrRate}
                    onChange={(e) => setRrRate(e.target.value)}
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 pl-8 font-black text-slate-900 focus:bg-white focus:border-orange-500 outline-none transition-all shadow-sm"
                  />
                </div>
              </div>
            </div>

            <button
              onClick={handleSubmit}
              className="w-full bg-orange-600 hover:bg-orange-700 text-white py-5 rounded-2xl font-black text-lg transition-all transform active:scale-[0.98] shadow-xl shadow-orange-600/30"
            >
              Calculate Premium
            </button>
          </div>

          {/* --- RESULTS SECTION --- */}
          <div className="bg-orange-50/80 p-10 border-t border-orange-100 text-center">
            <h4 className="text-[10px] font-black text-orange-600 uppercase tracking-widest mb-3 flex items-center justify-center gap-2">
              <Info size={14} /> Payable Premium Amount
            </h4>
            <div className="text-5xl font-black text-slate-900 tracking-tight">
              <span className="text-2xl mr-1 opacity-30 font-medium">₹</span>
              {premium || "0.00"}
            </div>
          </div>
        </div>
        
        {/* Subtle footer to ground the card */}
        <p className="text-center mt-8 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          UDCPR 2020 Compliance Engine
        </p>
      </main>
    </div>
  );
};

export default AncillaryFSICalculator;